import React, { useEffect, useState } from 'react';
import AdminHeader from '../../Header/AdminHeader';
import AdminFooter from '../../Footer/AdminFooter';
import AdminLeftMenu from '../../Navbar/AdminLeftMenu';
import Select from 'react-select';
import { useParams } from "react-router-dom";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import { CONFIG_LIST, CONFIG_LIST_ALL, } from "../../UI/Table/ColumnConst";
import { userloginDetails } from '../../Utils/AdminAuth';
import { HOST_URL, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../../Dashboard/api/Api';
import Axios from '../../../axios/Axios';

const DownloadHide = () => {
  const lStorage = userloginDetails();

  const [userId] = useState(lStorage?.user?.userId);
  const [token] = useState(lStorage?.token);
  const [userType] = useState(lStorage?.user?.isAdmin);

  const { id } = useParams();

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectUserID, setSelectUserID] = useState(null);
  const [userdata, setUserdata] = useState([]);

  const [checkBox, setCheckBox] = useState({
    all: 0,
    sms: 0,
    voice: 0,
    email: 0,
    whatsapp: 0,
    rcs: 0,
  });

  const [hideDigits, setHideDigits] = useState(null);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [bgColor, setBgColor] = useState('');
  const [allConfigList, setAllConfigList] = useState([]);
  const [userConfigList, setUserConfigList] = useState([]);

  const [enableEdit, setEnableEdit] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [status, setStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [toggleRow, setToggleRow] = useState(null);
  const [showToggleConfirm, setShowToggleConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);


  useEffect(() => {
    alluserList();

    if (!id) {
      fetchAllConfigList();
    }
  }, [id]);


  useEffect(() => {
    if (!id) return;

    setSelectUserID(id);
    fetchConfigList(id);
  }, [id]);


  const alluserList = async () => {
    try {
      const payload = {
        user_id: userId,
        method: 'retrieveall',
        type: userType,
        token: token,
      };

      const { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (data.success === true) {
        const users = data.data.map((u) => ({ label: u.username, value: u.id }));
        setUserdata(users);
      } else {
        setSuccessMessage(true);
        setBgColor('alert alert-danger alert-dismissible');
        setErrorMessage(data.message);
      }
    } catch (error) {
      console.error('Error fetching user list:', error);
      setSuccessMessage(true);
      setBgColor('alert alert-danger alert-dismissible');
      setErrorMessage('Something went wrong while fetching user list!');
    }
  };
  const fetchConfigList = async (selectUserID) => {
    try {
      const payload = {
        user_id: userId,
        token: token,
        method: "fetchConfig",
        retr_user_id: Number(selectUserID),
        filter_type: "UserWise"
      }
      const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/EncryptSettings`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (data.success === true) {
        setUserConfigList(data.data || []);
      }
      else {
        setUserConfigList([]);
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(data.message);
      }

    }
    catch (error) {
      setUserConfigList([]);
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage(error?.response?.data?.message || "Something went wrong while fetching config list");
    }
  }

  const fetchAllConfigList = async () => {
    try {
      const payload = {
        user_id: userId,
        token: token,
        method: "fetchConfig",
        filter_type: "FetchAll",
      };

      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/admin/EncryptSettings`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (data.success === true) {
        setAllConfigList(data.data || []);
      } else {
        setAllConfigList([]);
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(data.message);
      }
    } catch (error) {
      setAllConfigList([]);
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage(
        error?.response?.data?.message ||
        "Something went wrong while fetching all configs"
      );
    }
  };

  const handleEdit = (row) => {
    
    let userOption = userdata.find(u => Number(u.value) === Number(row.user_id));

    if (!userOption) {
      userOption = {
        label: row.username,
        value: row.user_id,
      };
    }

    setSelectedUser([userOption]);
    setSelectUserID(row.user_id);

    setHideDigits(row.digit_hide);

    setCheckBox({
      all: 0,
      sms: row.sms,
      voice: row.voice,
      email: row.email,
      whatsapp: row.whatsapp,
      rcs: row.rcs,
    });

    setStatus(row.status);
    setIsEdit(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const handleToggle = (row) => {
    setToggleRow(row);          // store row to toggle later
    setShowToggleConfirm(true); // open confirmation modal
  };

 const confirmToggle = async () => {
  if (!toggleRow) return;

  const newStatus = toggleRow.status === 1 ? 0 : 1;

  try {
    const payload = {
      user_id: userId,
      token: token,
      method: "SettingsConfig",  
      retr_user_id: Number(toggleRow.user_id),
      username: toggleRow.username || "",
      digit_hide: toggleRow.digit_hide,
      sms: toggleRow.sms,
      email: toggleRow.email,
      whatsapp: toggleRow.whatsapp,
      rcs: toggleRow.rcs,
      voice: toggleRow.voice,
      status: newStatus,          
    };

    const { data } = await Axios.post(
      `${NODE_HOST_URL_v1}/admin/EncryptSettings`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setSuccessMessage(true);
    setBgColor(
      data.success
        ? "alert alert-success alert-dismissible"
        : "alert alert-danger alert-dismissible"
    );
    setErrorMessage(data.message);

    
    if (data.success) {
      if (selectUserID) {
        fetchConfigList(selectUserID);
      } else {
        fetchAllConfigList();
      }
    }
  } catch (error) {
    setSuccessMessage(true);
    setBgColor("alert alert-danger alert-dismissible");
    setErrorMessage(
      error?.response?.data?.message || "Status update failed"
    );
  }

  setShowToggleConfirm(false);
  setToggleRow(null);
};




  const handleCheckboxAll = (e) => {
    const value = e.target.checked ? 1 : 0;

    setCheckBox({
      all: value,
      sms: value,
      voice: value,
      email: value,
      whatsapp: value,
      rcs: value,
    });
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    setCheckBox((prev) => ({
      ...prev,
      [name]: checked ? 1 : 0,
    }));
  };

  const handleChange = (users) => {
    const ids = users?.map((i) => i.value) || [];
    const selectedID = ids[0] || "";

    setSelectedUser(users);
    setSelectUserID(selectedID);

    if (selectedID) {
      fetchConfigList(selectedID);
    } else {
      setUserConfigList([]);
    }
  };

  const handleDelete = (row) => {
    setDeleteRow(row);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!deleteRow) return;

    try {
      const payload = {
        method: "deleteConfig",
        id: deleteRow.id,
        user_id: userId,
        token: token,
      };

      const { data } = await Axios.post(
        `${NODE_HOST_URL_v1}/admin/EncryptSettings`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      window.scrollTo(0, 0);

      setSuccessMessage(true);
      setBgColor(
        data.success
          ? "alert alert-success alert-dismissible"
          : "alert alert-danger alert-dismissible"
      );
      setErrorMessage(data.message);

      // refresh correct table
      if (data.success) {
        if (selectUserID) {
          fetchConfigList(selectUserID);
        } else {
          fetchAllConfigList();
        }
      }
    } catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage(
        error?.response?.data?.message || "Something went wrong while deleting!"
      );
    }

    setShowDeleteConfirm(false);
    setDeleteRow(null);
  };


  const addUser = async () => {
    try {
      const payload = {
        user_id: userId,
        token: token,
        method: 'SettingsConfig',
        retr_user_id: Number(selectUserID),
        username: selectedUser?.[0]?.label || "",
        digit_hide: hideDigits,
        sms: checkBox.sms,
        email: checkBox.email,
        whatsapp: checkBox.whatsapp,
        rcs: checkBox.rcs,
        voice: checkBox.voice,

        ...(isEdit && { status: status }),
      };
      console.log("PAYLOAD:", payload);
      const { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/EncryptSettings`, payload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      window.scrollTo(0, 0);

      setSuccessMessage(true);
      setBgColor(
        data.success ? 'alert alert-success alert-dismissible' : 'alert alert-danger alert-dismissible'
      );
      setErrorMessage(data.message);
      if (data.success) {
        const refreshID = selectUserID;

        setIsEdit(false);
        setStatus("");
        setSelectedUser(null);
        // setSelectUserID("");
        // setHideDigits(null);
        setSelectedUser((prev) => prev);
        setSelectUserID((prev) => prev);


        setCheckBox({
          all: 0,
          sms: 0,
          voice: 0,
          email: 0,
          whatsapp: 0,
          recharge: 0,
          notification: 0,
          rich_media: 0,
          fallback: 0,
          rcs: 0,
          chat: 0,
          flow: 0,
        });

        if (refreshID) {
          fetchConfigList(refreshID);
        }
      }


    } catch (error) {
      console.error('Error assigning plan:', error);
      setSuccessMessage(true);
      setBgColor('alert alert-danger alert-dismissible');
      setErrorMessage(error?.response?.data?.message || 'Something went wrong while assigning plan!');
    }
  };

  const handleSubmit = () => {
    if (isEdit) {
      setShowConfirm(true);   // open confirmation popup
    } else {
      addUser();              // direct add
    }
  };

  return (
    <div className="wrapper blog-cover">
      <AdminLeftMenu />

      <div className="main">
        <AdminHeader />

        <main className="content">
          <div className="container-fluid p-0">
            <div className="row mb-2 mb-xl-3">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  <strong>Download Hide</strong>
                </h3>
              </div>
            </div>

            <div className="row">
              <div className="col-12 d-flex">
                <div className="card table-content-show flex-fill">
                  <div className="card-body">
                    {successMessage && (
                      <div className={bgColor} role="alert">
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                        <div>{errorMessage}</div>
                      </div>
                    )}


                    <form>
                      <div className="form-row">
                        <label className="form-label">Select User</label>

                        <div className="input-group col-md-12 mb-2">
                          <Select
                            value={selectedUser}
                            onChange={handleChange}
                            options={userdata}
                            placeholder="Enter user Name"
                            isMulti
                            closeMenuOnSelect
                          />
                        </div>
                      </div>
                      {/* CHANNELS */}
                      {/* NO. OF DIGITS TO HIDE */}
                      <div className="form-row">
                        <label className="form-label">No. of digits to hide</label>

                        <div className="input-group col-md-12 mb-2">
                          <Select
                            options={[4, 6].map((n) => ({ label: n, value: n }))}
                            value={
                              hideDigits !== null
                                ? { label: hideDigits, value: hideDigits }
                                : null
                            }
                            onChange={(option) => setHideDigits(option?.value || null)}
                            placeholder="Select digits"
                            isSearchable={false}
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <label className="form-label">Channels</label>
                        <div className="input-group col-md-12 mb-2">
                          {[
                            ["all", "All"],
                            ["sms", "SMS"],
                            ["voice", "Voice"],
                            ["email", "Email"],
                            ["whatsapp", "Whatsapp"],
                            ["rcs", "RCS"],
                          ].map(([key, label]) => (
                            <div className="form-check col-md-2" key={key}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name={key}
                                checked={checkBox[key] === 1}
                                onChange={key === "all" ? handleCheckboxAll : handleCheckbox}
                              />
                              <label className="form-check-label">{label}</label>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="float-right mt-3">
                        <input
                          onClick={handleSubmit}
                          type="button"
                          value={isEdit ? "Update" : "Add"}
                          className="btn btn-sm btn-primary"
                        />
                      </div>
                    </form>


                  </div>
                </div>
              </div>
            </div>
            <AdvanceDataTable
              tableCell={
                selectUserID
                  ? CONFIG_LIST(handleToggle, enableEdit, handleEdit)
                  : CONFIG_LIST_ALL(handleToggle, enableEdit, handleEdit, handleDelete)
              }
              tableData={selectUserID ? userConfigList : allConfigList}
              pagination={true}
              filterstatus={false}
            />

          </div>
          {showConfirm && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                backdropFilter: "blur(6px)",
                zIndex: 1050,
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 24px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
                  animation: "modalFade 0.25s ease",
                }}
              >
                {/* Title */}
                <h5
                  style={{
                    fontWeight: 600,
                    marginBottom: "10px",
                    color: "#0f172a",
                  }}
                >
                  Confirm Update
                </h5>

                {/* Message */}
                <p
                  style={{
                    fontSize: "14px",
                    color: "#475569",
                    marginBottom: "22px",
                    lineHeight: 1.5,
                  }}
                >
                  Are you sure you want to update this configuration?
                  This change will immediately apply to the selected user.
                </p>

                {/* Actions */}
                <div className="d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: "#f1f5f9",
                      color: "#334155",
                      borderRadius: "8px",
                      padding: "6px 16px",
                      fontWeight: 500,
                      border: "none",
                    }}
                    onClick={() => setShowConfirm(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      setShowConfirm(false);
                      addUser();
                    }}
                  >
                    Yes, Update
                  </button>
                </div>
              </div>

              {/* Animation style */}
              <style>
                {`
        @keyframes modalFade {
          from { transform: translateY(10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}
              </style>
            </div>
          )}
          {showToggleConfirm && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                backdropFilter: "blur(6px)",
                zIndex: 1050,
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 24px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
                  animation: "modalFade 0.25s ease",
                }}
              >
                <h5 style={{ fontWeight: 600, marginBottom: 10, color: "#0f172a" }}>
                  Confirm Status Change
                </h5>

                <p style={{ fontSize: 14, color: "#475569", marginBottom: 22 }}>
                  Are you sure you want to{" "}
                  <strong>
                    {toggleRow?.status === 1 ? "disable" : "enable"}
                  </strong>
                  {" "}
                  this configuration?
                </p>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: "#f1f5f9",
                      color: "#334155",
                      borderRadius: "8px",
                      padding: "6px 16px",
                      border: "none",
                    }}
                    onClick={() => setShowToggleConfirm(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-sm btn-primary"
                    onClick={confirmToggle}
                  >
                    {toggleRow?.status === 1 ? "Yes Disable" : "Yes Enable"}

                  </button>
                </div>
              </div>
            </div>
          )}
          {showDeleteConfirm && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                backdropFilter: "blur(6px)",
                zIndex: 1050,
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  background: "#ffffff",
                  borderRadius: "16px",
                  padding: "28px 24px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
                  animation: "modalFade 0.25s ease",
                }}
              >
                <h5 style={{ fontWeight: 600, marginBottom: 10, color: "#0f172a" }}>
                  Delete Configuration
                </h5>

                <p style={{ fontSize: 14, color: "#475569", marginBottom: 22 }}>
                  Are you sure you want to delete this configuration?
                  <br />
                  <strong>This action cannot be undone.</strong>
                </p>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    className="btn btn-sm"
                    style={{
                      background: "#f1f5f9",
                      color: "#334155",
                      borderRadius: "8px",
                      padding: "6px 16px",
                      border: "none",
                    }}
                    onClick={() => {
                      setShowDeleteConfirm(false);
                      setDeleteRow(null);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={confirmDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          )}

        </main>

        <AdminFooter />
      </div>
    </div>
  );
};

export default DownloadHide;
